/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exercise_Personal_Goal_RemoveInputs */

const en_us2_exercise_personal_goal_remove = /** @type {(inputs: Exercise_Personal_Goal_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove goal`)
};

const pt_br2_exercise_personal_goal_remove = /** @type {(inputs: Exercise_Personal_Goal_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover meta`)
};

const es_419_exercise_personal_goal_remove = /** @type {(inputs: Exercise_Personal_Goal_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quitar meta`)
};

const pt_pt2_exercise_personal_goal_remove = /** @type {(inputs: Exercise_Personal_Goal_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover objetivo`)
};

const fr_fr2_exercise_personal_goal_remove = /** @type {(inputs: Exercise_Personal_Goal_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retirer l'objectif`)
};

const de_de2_exercise_personal_goal_remove = /** @type {(inputs: Exercise_Personal_Goal_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ziel entfernen`)
};

const it_it2_exercise_personal_goal_remove = /** @type {(inputs: Exercise_Personal_Goal_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rimuovi obiettivo`)
};

/**
* | output |
* | --- |
* | "Remove goal" |
*
* @param {Exercise_Personal_Goal_RemoveInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const exercise_personal_goal_remove = /** @type {((inputs?: Exercise_Personal_Goal_RemoveInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exercise_Personal_Goal_RemoveInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_exercise_personal_goal_remove(inputs)
	if (locale === "es-419") return es_419_exercise_personal_goal_remove(inputs)
	if (locale === "pt-PT") return pt_pt2_exercise_personal_goal_remove(inputs)
	if (locale === "fr-FR") return fr_fr2_exercise_personal_goal_remove(inputs)
	if (locale === "de-DE") return de_de2_exercise_personal_goal_remove(inputs)
	if (locale === "it-IT") return it_it2_exercise_personal_goal_remove(inputs)
	return en_us2_exercise_personal_goal_remove(inputs)
});
export { exercise_personal_goal_remove as "exercise-personal.goal_remove" }